import { cn } from "@/utils";

const MAP = {
  // consultation statuses
  pending:     "bg-amber-50 text-amber-700 border-amber-200",
  assigned:    "bg-blue-50 text-blue-700 border-blue-200",
  scheduled:   "bg-indigo-50 text-indigo-700 border-indigo-200",
  completed:   "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled:   "bg-red-50 text-red-500 border-red-200",
  rejected:    "bg-gray-100 text-gray-500 border-gray-200",
  // user / admin statuses
  active:      "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive:    "bg-gray-100 text-gray-500 border-gray-200",
  suspended:   "bg-red-50 text-red-600 border-red-200",
  // appointment statuses
  confirmed:   "bg-blue-50 text-blue-700 border-blue-200",
  rescheduled: "bg-purple-50 text-purple-700 border-purple-200",
  new:         "bg-[hsl(var(--zt-gold))]/10 text-[hsl(var(--zt-gold))] border-[hsl(var(--zt-gold))]/25",
  // roles
  admin:       "bg-[hsl(var(--zt-teal))]/10 text-[hsl(var(--zt-teal))] border-[hsl(var(--zt-teal))]/20",
  super_admin: "bg-[hsl(var(--zt-gold))]/15 text-[hsl(var(--zt-teal))] border-[hsl(var(--zt-gold))]/30",
  advisor:     "bg-indigo-50 text-indigo-700 border-indigo-200",
  user:        "bg-gray-100 text-gray-600 border-gray-200",
};

export default function StatusBadge({ status, className }) {
  const s = (status || "").toLowerCase();
  return (
    <span
      className={cn(
        "inline-flex items-center font-heading uppercase tracking-[0.15em] text-[9px] font-bold px-2.5 py-1 rounded-full border",
        MAP[s] || "bg-gray-100 text-gray-600 border-gray-200",
        className
      )}
    >
      {status || "—"}
    </span>
  );
}
